// extracted by mini-css-extract-plugin
export default {"draggable":"common_draggable__qpf3N","nonDraggable":"common_nonDraggable__QwE8B"};